import { render, staticRenderFns } from "./PosDetailProductData.vue?vue&type=template&id=81832db6&scoped=true&"
import script from "./PosDetailProductData.vue?vue&type=script&lang=js&"
export * from "./PosDetailProductData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81832db6",
  null
  
)

export default component.exports